import { array, date, InferType, mixed, object, string } from "yup";
import { PendingChangeDecisionEnum } from "@sinch/core/entities/serverEnums";

export const attributeEditSchema = object({
  attributeId: string().nullable(),
  type: string<"system" | "attribute">().required(),
  fieldName: string().nullable(),
  value: mixed().nullable(),
  expirationDate: date().nullable(),
});

export const profileReviewSchema = object({
  attributes: array().of(attributeEditSchema).required().default([]),
});

export type ProfileReviewFormFields = InferType<typeof profileReviewSchema>;
export type AttributeEditFormFields = InferType<typeof attributeEditSchema>;

export const pendingProfileChangeAttributeSchema = object({
  changeId: string().required(),
  decision: string<PendingChangeDecisionEnum>().nullable(),
  note: string().nullable(),
}).concat(attributeEditSchema);

export type PendingProfileChangeAttributeSchemaFormFields = InferType<typeof pendingProfileChangeAttributeSchema>;

export const pendingProfileChangeSchema = object({
  attributes: array().of(pendingProfileChangeAttributeSchema).required().default([]),
});
export type PendingProfileChangeSchemaFormFields = InferType<typeof pendingProfileChangeSchema>;
